import { render, staticRenderFns } from "./FieldsFile.vue?vue&type=template&id=70b9f792&"
import script from "./FieldsFile.vue?vue&type=script&lang=js&"
export * from "./FieldsFile.vue?vue&type=script&lang=js&"
import style0 from "./FieldsFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports